import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  importButton: {
    padding: theme.spacing(2),
    '& .MuiTypography-button': {
      display: 'flex',
    },
    width: '100%',
  },
  importButtonText: {
    color: 'inherit',
    fontSize: '0.875rem',
    fontWeight: 500,
  },
}));

export default useStyles;
